var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var BetBtnOdd = /** @class */ (function (_super) {
    __extends(BetBtnOdd, _super);
    function BetBtnOdd(props) {
        var _this = _super.call(this, props) || this;
        _this.oddDataUat = _this.props.dataUat ? _this.props.dataUat.odds : "bet-odds-value";
        return _this;
    }
    BetBtnOdd.prototype.render = function () {
        return (React.createElement("span", { className: "bet_btn-odd", "data-uat": this.oddDataUat }, this.props.odd || "-"));
    };
    return BetBtnOdd;
}(React.PureComponent));
export { BetBtnOdd };
//# sourceMappingURL=BetBtnOdd.js.map